

export default {
    drd: {
        airway: []
    },
    upload: null
}